import { render, staticRenderFns } from "./IrregularNecesities.vue?vue&type=template&id=63c8ea32"
import script from "./IrregularNecesities.vue?vue&type=script&lang=js"
export * from "./IrregularNecesities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports